import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import DataMapper from '../components/DataMapper';

const hasAnEventMappingConfiguration = mapping =>
	typeof Object.values(mapping).find(
		val => typeof val.event !== 'undefined'
	) !== 'undefined';

const WidgetContainer = ({ mapping = {} }) => {
	useEffect(() => {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = mapping;
		if (window && window.DDC && window.DDC.pubsub) {
			window.DDC.pubsub.publish('ws-tagging-ready');
		}
	});

	return (
		hasAnEventMappingConfiguration(mapping) && (
			<DataMapper appIsMounted={null} />
		)
	);
};

WidgetContainer.propTypes = {
	mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = state => {
	return {
		mapping: state.mapping
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
